import { URL_BASE_API } from '../../configs/urlConfigs';

import service from '../api';

export const csvTemplateImport = (request) => { 
    let ENDPOINT = URL_BASE_API+'affiliate/csv-import-template/'; 
    if(request.data!==undefined) { 
        ENDPOINT = URL_BASE_API+'affiliate/csv-import-template/?template_type='+request.data.templateType;
    }
    return service.get(ENDPOINT); 
}; 

